import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useMediaQuery from '@mui/material/useMediaQuery';
import ReactCrop from 'react-image-crop';
import FormControl from './FormControl';
import Button from './Button';
import Confirmation from './Confirmation';
import ModalActions from './ModalActions';
import 'react-image-crop/dist/ReactCrop.css';
import { StyledEditor } from './AvatarCropDialog.styled';
function AvatarCropDialog(_ref) {
  var helperText = _ref.helperText,
    label = _ref.label,
    showError = _ref.showError,
    errorMessage = _ref.errorMessage,
    onSave = _ref.onSave,
    onDelete = _ref.onDelete,
    droppedFile = _ref.droppedFile;
  var isNotMobile = useMediaQuery(function (theme) {
    return theme.breakpoints.up('md');
  });
  var _useState = useState({
      aspect: 1,
      unit: '%',
      width: 100
    }),
    crop = _useState[0],
    setCrop = _useState[1];
  var _useState2 = useState(null),
    originalImage = _useState2[0],
    setOriginalImage = _useState2[1];
  var _useState3 = useState(false),
    confirmDelete = _useState3[0],
    setConfirmDelete = _useState3[1];
  var _useState4 = useState('100%'),
    editorWidth = _useState4[0],
    setEditorWidth = _useState4[1];
  var _useState5 = useState(false),
    saving = _useState5[0],
    setSaving = _useState5[1];
  var _useState6 = useState(false),
    cancelling = _useState6[0],
    setCancelling = _useState6[1];
  var handleCancel = function handleCancel() {
    setCancelling(true);
    onDelete().then(function () {
      setOriginalImage(null);
      setConfirmDelete(false);
      setCancelling(false);
    });
  };
  var handleCropChange = function handleCropChange(newCrop) {
    return setCrop(newCrop);
  };
  var handleImageLoaded = function handleImageLoaded(image) {
    var width = image.width;
    if (window.innerHeight * 0.7 < image.height) {
      width = image.width * (window.innerHeight * 0.7 / image.height);
    }
    if (width < window.innerWidth * 0.7) {
      setEditorWidth(width + "px");
    }
    var widthPercent = image.width < image.height ? 1 : image.height / image.width;
    var heightPercent = image.width > image.height ? 1 : image.width / image.height;
    var y = (1 - heightPercent) / 2;
    var x = (1 - widthPercent) / 2;
    var height = image.height * (width / image.width);
    setCrop({
      unit: 'px',
      width: width * widthPercent,
      height: height * heightPercent,
      x: width * x,
      y: height * y,
      aspect: 1
    });
    setOriginalImage(image);
    return false;
  };
  var handleImageSave = function handleImageSave() {
    if (originalImage && crop.width && crop.height) {
      var canvas = document.createElement('canvas');
      var scaleX = originalImage.naturalWidth / originalImage.width;
      var scaleY = originalImage.naturalHeight / originalImage.height;
      canvas.width = crop.width;
      canvas.height = crop.height;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(originalImage, crop.x * scaleX, crop.y * scaleY, crop.width * scaleX, crop.height * scaleY, 0, 0, crop.width, crop.height);
      return new Promise(function (resolve, reject) {
        return canvas.toBlob(function (blob) {
          if (!blob) {
            // eslint-disable-next-line no-console
            console.error('Canvas is empty');
            reject();
          }
          setSaving(true);
          var reader = new FileReader();
          reader.addEventListener('load', function () {
            onSave(reader.result, blob).then(function () {
              return resolve();
            });
          });
          reader.readAsDataURL(blob);
        }, 'image/jpeg', 0.6);
      });
    }
    return false;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormControl, {
    key: "form-control",
    name: "avatar-crop-editor",
    fullWidth: true,
    label: label,
    helperText: helperText,
    showError: showError,
    errorMessage: errorMessage
  }, /*#__PURE__*/React.createElement(StyledEditor, {
    showError: showError
  }, /*#__PURE__*/React.createElement(ReactCrop, {
    src: droppedFile,
    crop: crop,
    style: {
      width: editorWidth,
      maxHeight: window.innerHeight * 0.7
    },
    circularCrop: true,
    onChange: handleCropChange,
    onImageLoaded: handleImageLoaded,
    keepSelection: true
  }))), /*#__PURE__*/React.createElement(ModalActions, null, /*#__PURE__*/React.createElement(Button, {
    onClick: handleCancel,
    variant: "outlined",
    loading: cancelling,
    color: "primaryAlt",
    fullWidth: !isNotMobile
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    onClick: handleImageSave,
    loading: saving,
    color: "primaryAlt",
    fullWidth: !isNotMobile
  }, "Save")), /*#__PURE__*/React.createElement(Confirmation, {
    open: confirmDelete,
    onCancel: function onCancel() {
      return setConfirmDelete(false);
    },
    onConfirm: handleCancel,
    message: "Are you sure you want to remove the attached image?"
  }));
}
AvatarCropDialog.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Whether or not to display an error message (if there is a message to display).
   */
  showError: PropTypes.bool,
  /**
   * The error message to display if showError === true
   */
  errorMessage: PropTypes.string,
  /**
   * The helper text content.
   */
  helperText: PropTypes.node,
  /**
   * Do something when user saves cropped image, received the base64 string
   */
  onSave: PropTypes.func,
  /**
   * Do something when user removes image
   */
  onDelete: PropTypes.func,
  /**
   * The label content.
   */
  label: PropTypes.string,
  /**
   * Result from dropzone...
   */
  droppedFile: PropTypes.any
} : {};
AvatarCropDialog.defaultProps = {
  helperText: '',
  onSave: function onSave() {
    return Promise.resolve(true);
  },
  onDelete: function onDelete() {
    return Promise.resolve(true);
  },
  label: '',
  showError: false,
  errorMessage: '',
  droppedFile: null
};
export default AvatarCropDialog;